export default __webpack_public_path__ + "static/media/atomic-design-5.fa5f1f3d.webp";